export enum PlanningCreateStatus {
    Pending = 0,
    Success = 1,
    Failure = 2,
    Invalid = 3
}

export const PlanningCreateStatusMetadata = {
    '0': {
        display: 'Pending',
        value: 0
    },
    '1': {
        display: 'Success',
        value: 1
    },
    '2': {
        display: 'Failed',
        value: 2
    },
    '3': {
        display: 'Invalid State',
        value: 3
    }
};
